import React from "react";
import { Card, Descriptions, Typography } from "antd";
import { isAdminUser } from "../../../services/authService";
import styles from "./OperationRequestWorkspace.module.css";

const { Text } = Typography;

/**
 * @param {{ supplierInfo: Record<string, unknown> }} props
 */
export default function OperationRequestAdminMetaCard({ supplierInfo }) {
  if (!isAdminUser()) return null;
  return (
    <Card className={styles.sidebarCard} size="small" title="מידע מערכת (אדמין)">
      <Descriptions column={1} size="small" bordered>
        <Descriptions.Item label="Booking ref">
          <Text dir="ltr">{supplierInfo.bookingRef || "—"}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Deal / LDS">
          <span dir="ltr">
            {supplierInfo.dealType || "—"}
            {supplierInfo.dealId ? ` · id ${supplierInfo.dealId}` : ""}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label="מזהה רשומה (DB)">
          <Text dir="ltr">{supplierInfo.ldsOrderDbId || "—"}</Text>
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
